<template>
  <section :class="['section', sectionStyle]">
    <h3 v-if="showHeading" class="section-header">{{ heading }}</h3>
    <div v-html="htmlContent"></div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { marked } from 'marked';

export default defineComponent({
  name: 'ContentSection',
  props: {
    heading: {
      type: String,
      default: '',
    },
    showHeading: {
      type: Boolean,
      default: true,
    },
    content: {
      type: String,
      default: '',
    },
    sectionStyle: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
        htmlContent: marked.parse(this.content),
    }
  }
});
</script>
